import moment from 'moment';

export class PrescriptionListingModel {
  constructor(
    public prescriptionID: string,
    public reference: string,
    public prescriptionDate: moment.Moment,
    public dispenseQuantity: number,
    public dispenseUnit: string,
    public dosage: string,
    public dosageForm: string,
    public medication: string,
    public directions: string,
    public refill: number,

    public doctorID: string,
    public doctorName: string,

    public pharmacyID: string,
    public pharmacyName: string,
    public pharmacyPhoneNumber: string,

    public jsonString: string,

    public lastNote: string,
    public eRxPharmacyID: string,
    public eRxPharmacyName: string
  ) { }
}
